import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { AppState } from 'src/store/appstate';

@Component({
  selector: 'tcs-client-sync-status',
  templateUrl: './client-sync-status.component.html',
  styleUrls: ['./client-sync-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientSyncStatusComponent {
  public subscribedChannels$: Observable<string[]>;

  constructor(private _store: Store<AppState>) {
    this.subscribedChannels$ = this._store
      .select((x) => x.pubnub.channels)
      .pipe(
        distinctUntilChanged(),
        map((c) => c.toArray()),
      );
  }
}
